import { useEffect, useRef } from "react";
import { app } from "@microsoft/teams-js";
import { TrackJS } from "trackjs";
import { setTenantInfo } from "../store/auth.duck";
import { useDispatch } from "react-redux";
import { checkTenant } from '@shared/services/AccessService';
import { useMsal } from "@azure/msal-react";
import { isInTeams } from '@shared/utils/TeamsUtils';

export function WithTenantChecker() {
  const dispatch = useDispatch();
  const {instance} = useMsal();
  const loading = useRef(false);

  useEffect(() => {
    if (loading.current || !!localStorage.getItem('idToken')) return;

    if (isInTeams()) {
      app.initialize().then(() => app.getContext()).then((ctx: app.Context) => {
        if (ctx.user && ctx.user.tenant?.id) {
          loading.current = true;
          checkTenant(ctx.user.tenant.id)
            .then(resp => dispatch(setTenantInfo(resp || undefined)))
            .catch((e) => TrackJS?.track(`[WithTenantChecker] checkTenant failed in Teams: ${String(e?.message ?? e).slice(0, 200)}`))
            .finally(() => loading.current = false);
        }
      }).catch(() => {
        // Teams SDK context is unavailable in some embeds — tenant info is optional here.
      })
    } else {
      loading.current = true;
      checkTenant(instance.getActiveAccount()?.tenantId)
        .then(resp => dispatch(setTenantInfo(resp || undefined)))
        .catch((e) => TrackJS?.track(`[WithTenantChecker] checkTenant failed: ${String(e?.message ?? e).slice(0, 200)}`))
        .finally(() => loading.current = false);
    }
  }, [dispatch, instance]);
}
